import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { _serverUrl2 } from "../../../config";
import { failed } from "../../../Utils/Alerts";
import { loadingSc } from "../../Layout/AlertDiv";

export default function TeamDashboard() {
  const history = useHistory();

  const [data, setData] = useState([]);
  const getInfosFromNode = async () => {
    await axios
      .get(_serverUrl2 + "/team/getAllData")
      .then((res) => {
        if (res.data.status) {
          console.log("a");
          setData(res.data.rows);
        } else {
          failed("Veriler Getirilemedi");
        }
      })
      .catch(() => {
        failed("Hata Oluştu");
      })
      .finally(() => {
        loadingSc(false);
      });
  };

  const ekle = async () => {
    let json = {
      ekip_adi: document.getElementById("yeniEkipAdi").value,
      ekip_aciklama: document.getElementById("YeniEkipAciklama").value,
    };
    await axios.post(_serverUrl2 + "/team/addData", json).then((res) => {
      if (res.data.status) {
        console.log(res.data.rows, "addData");
        getInfosFromNode();
        document.getElementById("YeniKayitForm").style.display = "none";
      } else {
        failed("Veriler Getirilemedi");
      }
    });
  };

  useEffect(() => {
    getInfosFromNode();
  }, []);

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="textBox">
          <div className="content">Ekip Yönetimi</div>
        </div>
      </div>

      <div className="col-sm-12 textBox">
        <table
          className="table table-sm table-bordered"
          id="YeniKayitForm"
          style={{ fontSize: "12px", display: "none", textAlign: "center", borderLeft: "10px solid #007095", backgroundColor: "rgba(255,165,0,0.05)" }}
        >
          <tbody>
            <tr>
              <th>Ekip Adı</th>
              <th>Açıklama</th>
              <th>
                <button
                  className="orangeBtn"
                  onClick={() => {
                    document.getElementById("YeniKayitForm").style.display = "none";
                  }}
                >
                  Kapat
                </button>
              </th>
            </tr>
            <tr>
              <td>
                <input id="yeniEkipAdi"></input>
              </td>
              <td>
                <input id="YeniEkipAciklama"></input>
              </td>
              <td>
                <button className="blueBtn" onClick={(e) => ekle(e)}>
                  Kaydet
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="col-sm-12 textBox">
        <table
          className="table table-sm table-bordered"
          style={{ fontSize: "12px", textAlign: "center", borderLeft: "10px solid #007095", backgroundColor: "rgba(255,165,0,0.05)" }}
        >
          <tbody>
            <tr>
              <th>Ekip Adı</th>
              <th>Açıklama</th>
              <th>
                <button
                  className="blueBtn"
                  style={{ width: "75%", fontSize: "10px" }}
                  onClick={() => {
                    document.getElementById("YeniKayitForm").style.display = "block";
                  }}
                >
                  Ekle
                </button>
              </th>
            </tr>

            {data.map((d) => {
              return (
                <tr>
                  {" "}
                  <td>{d.ekip_adi}</td>
                  <td>{d.ekip_aciklama}</td>
                  <td>
                    <button className="orangeBtn" style={{ width: "75%", fontSize: "10px" }} onClick={() => history.push("/dashboard/team/info/" + d.id)}>
                      Düzenle
                    </button>
                  </td>
                  {/* <td><button className='orangeBtn' onClick={() => ekipSil()}>Sil</button></td> */}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
